<template>
  <v-container grid-list-xl departmentContainer>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <center style="width: 100%"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="departmentLoader == true" /></center>
        <v-tabs class="departmentEditTabs" slider-color="grey" v-if="departmentLoader== false">
          <v-tab class="tab" :key="1" ripple>Details</v-tab>
          <v-tab class="tab" :key="2" ripple>Calculator</v-tab>
          <v-tab class="tab" :key="3" ripple>Product Codes</v-tab>
          <v-tab class="tab" :key="4" ripple>User List</v-tab>
          <v-tab class="tab" :key="5" ripple>Status Rules</v-tab>
          <v-tab class="tab" :key="6" ripple>Widget Rules</v-tab>
          <!--<v-tab class="tab" :key="7" ripple>Article to Installation</v-tab>-->
          <v-tab class="tab" :key="7" ripple>Quote Edit Screen</v-tab>
          <v-tab class="tab" :key="8" ripple>Article Margins</v-tab>
          <v-tab class="tab" :key="9" ripple>Delivery Note Setup</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg6>
                  <label class="blackLabel">* Department Name:</label>
                  <v-text-field label="Name" v-model="objDepartmentEdit.name" required :rules="nameRules" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Department Description:</label>
                  <v-text-field label="Description" v-model="objDepartmentEdit.description" required :rules="descriptionRules" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Department Terms & Conditions Link:</label>
                  <v-text-field label="Terms and Conditions" v-model="objDepartmentEdit.terms_and_conditions" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Can Edit Quotes For This Department:</label>
                  <v-switch label="Can Edit Quotes For This Department" v-model="objDepartmentEdit.hide_quote_edit"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Department Sales Margin:</label>
                  <v-text-field label="Department Margin" v-model="objDepartmentEdit.department_margin" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Department Installation Margin:</label>
                  <v-text-field label="Department Margin" v-model="objDepartmentEdit.department_installation_margin" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Can Update Sales Margin:</label>
                  <v-switch label="Can Update Sales Margin" v-model="objDepartmentEdit.can_update_sales_margin"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Can Update Installation Margin:</label>
                  <v-switch label="Can Update Installation Margin" v-model="objDepartmentEdit.can_update_installation_margin"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Can Update Sales Cost Price:</label>
                  <v-switch label="Can Update Cost Price" v-model="objDepartmentEdit.can_update_cost_price"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Can Update Installation Cost Price:</label>
                  <v-switch label="Can Update Installation Cost Price" v-model="objDepartmentEdit.can_update_cost_price_installation"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Show Spec Data in PO Document:</label>
                  <v-switch label="Show Spec Data in PO Document" v-model="objDepartmentEdit.show_po_spec"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">App Starting Status:</label>
                  <v-select :items="statusList" class="dropdown" placeholder="App Starting Status" v-model="objDepartmentEdit.app_starting_status" item-value="id" item-text="description" autocomplete solo single-line></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>

                </v-flex>
                <v-flex lg12>
                  <label class="blackLabel">Department Ranges:</label>
                  <div class="screenTip" style="margin: 16px;">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> These are the calculators
                      that will be available in the dropdowns on the Edit Quote Screen.
                    </span>
                  </div>
                  <v-select :items="departmentRangesList" v-model="objDepartmentEdit.ranges" item-value="id32" :rules="branchRules" item-text="name" label="Department Ranges" autocomplete solo multiple></v-select>
                </v-flex>
                <v-flex lg12>
                  <label class="blackLabel">Department Starting Filter:</label>
                  <div class="screenTip" style="margin: 16px;">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i>
                      Each calculator will have a dropdown to allow filtering articles by product type.
                      This filter is created by using the names of the properties in the MyQuote groupings. <br>
                      You can default the filter to the main product by adding the name of the product property as the starting filter.  <br>
                      <b>Example:</b> In the laminated flooring calculator default the filter to show the laminated products by adding 'code_laminated flooring' as the starting filter.
                    </span>
                  </div>
                  <v-data-table loading="true" :headers="rangeHeaders" :items="rangeFilters" ref="sortableTable" :search="search"
                                hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <tr class="sortableRow" id="rows">
                        <td width="45%"><v-select :items="departmentRangesList" v-model="props.item.range" item-value="id32" item-text="name" label="Department Range" autocomplete solo></v-select></td>
                        <td width="45%"><v-text-field label="Filter" v-model="props.item.filter" single-line solo></v-text-field></td>
                        <td width="10%"><a @click.prevent="fncDeleteFilter(props.index)"><i class="material-icons">delete</i></a></td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-btn @click="fncAddRangeFilter()" color="success">Add Range Filter</v-btn>
                  <!--<v-select :items="departmentRangesList" v-model="objDepartmentEdit.ranges" item-value="id32" :rules="branchRules" item-text="name" label="Department Ranges" autocomplete solo multiple></v-select>-->
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <div class="screenTip">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> These are the codes/articles
                      that will be available on the Edit Quote Screen. Find them in the calculator dropdown under the 'Made to Measure' option.
                      <br><b>NOTE: </b>
                      <ol>
                        <li>All articles added here will be editable on the Edit Quote Screen regardless of whether they were added using a
                          calculator.</li>
                        <li>The article will only display on the Edit Quote Screen if it is mapped to a vendor, the vendor is available for the store you are
                          in and the article exists on M050. Store ranging does NOT apply to these articles.</li>
                        <li>An installation article will display in the installation dropdown on the Edit Quote Screen if the article is added to the this screen as well as the installation
                        list in MyOrder.</li>
                        <li style="color: red">Make sure there are no blank fields as this will cause issues!</li>
                      </ol>
                    </span>
                  </div>
                </v-flex>
                <v-flex lg12>
                  <input type="file" id="articleImport" @change="fncSetImageObj">
                </v-flex>
                <v-flex lg3 v-for="(product_code, index) in objDepartmentEdit.product_codes">
                  <v-text-field label="Product Code" v-model="objDepartmentEdit.product_codes[index].value" single-line solo></v-text-field>
                  <a @click="fncRemoveDepartmentRange(index)" class="departmentRangeRemove">Remove</a>
                </v-flex>
                <v-flex lg3>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddProductCode()">Add Product Code</v-btn>
                </v-flex>
                <!--<v-flex lg12>
                  <label class="blackLabel">* Bank Details:</label>
                  <v-text-field label="Bank Details" v-model="objDepartmentEdit.bank_details" multi-line solo></v-text-field>
                  <v-switch label="Override Store Bank Details" v-model="objDepartmentEdit.bank_override"></v-switch>
                </v-flex>
                <v-flex lg12>
                  <label class="blackLabel">* Terms and Conditions:</label>
                  <v-text-field label="Terms and Conditions" v-model="objDepartmentEdit.terms_and_conditions" multi-line solo></v-text-field>
                </v-flex>-->
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <v-data-table loading="true" :headers="headers" :items="departmentUsers" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1 departmentUserList">
                    <template slot="items" slot-scope="props">
                      <tr class="sortableRow" id="rows">
                        <td width="50%">{{ props.item.name }}</td>
                        <td width="50%" class="text-xs-right">{{ props.item.surname }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <v-btn color="info" @click="fncAddStatusRules">Add Rule</v-btn>
                </v-flex>
                <v-data-table loading="true" :headers="ruleHeaders" :items="objDepartmentEdit.status_rules" v-if="objDepartmentEdit.status_rules != null && objDepartmentEdit.status_rules != 'null' && objDepartmentEdit.status_rules.length > 0" hide-actions disable-initial-sort class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="15%">
                        <v-select style="margin-top: 4px !important;" :items="serviceType" placeholder="Service Type" class="dropdown" v-model="props.item.type" item-value="id" item-text="name" outline autocomplete></v-select>
                      </td>
                      <td width="20%">
                        <v-select style="margin-top: 4px !important;" :items="userRoles" placeholder="Roles" class="dropdown" v-model="props.item.originator" item-value="id" item-text="name" multiple outline autocomplete></v-select>
                      </td>
                      <td width="25%">
                        <v-select style="margin-top: 4px !important;" :items="userRoles" placeholder="Roles" class="dropdown" v-model="props.item.roles" item-value="id" item-text="name" multiple outline autocomplete></v-select>
                      </td>
                      <td width="15%">
                        <v-select style="margin-top: 4px !important;" :items="designationType" placeholder="Designation" class="dropdown" v-model="props.item.designation" item-value="id" item-text="name" multiple outline autocomplete></v-select>
                      </td>
                      <td width="15%">
                        <v-select style="margin-top: 4px !important;" :items="statusList" placeholder="Status" class="dropdown" v-model="props.item.status" item-value="id" item-text="description" outline autocomplete></v-select>
                      </td>
                      <td width="10%"><a @click="fncDeleteStatusRule(props.item)">Delete</a></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="6">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-expansion-panel focusable>
                  <v-expansion-panel-content v-for="(widget, key) in objWidgetEdit.widgets" :key="key" :value="key === 'ESCALATION'">
                    <template v-slot:header>{{ widget.title }}</template>
                    <v-container grid-list-xs fluid widgetRules>
                      <v-layout class="widgetRulesHeader">
                        <v-flex xs3><div class="title pl-2 pr-2">Group</div></v-flex>
                        <v-flex xs3><div class="title">Start Status</div></v-flex>
                        <v-flex xs3><div class="title">End Status</div></v-flex>
                        <v-flex xs3><div class="title">Period</div></v-flex>
                      </v-layout>
                      <v-layout v-for="statusGroup in widget.groups">
                        <v-flex xs3 style="vertical-align: center"><div class="subheading pl-2 pr-2 pt-3">{{ statusGroup.label }}</div></v-flex>
                        <v-flex xs3><status-selector :status-list="departmentStatuses" label="Select Initial Status" v-model="statusGroup.status_initial" :selected-collection="typeof selectedWidgetStatusCollection[key] !== 'undefined' ? selectedWidgetStatusCollection[key] : []"></status-selector></v-flex>
                        <v-flex xs3><status-selector :status-list="departmentStatuses" label="Select End Status" v-model="statusGroup.status_end" :selected-collection="typeof selectedWidgetStatusCollection[key] !== 'undefined' ? selectedWidgetStatusCollection[key] : []"></status-selector></v-flex>
                        <v-flex xs3><period-selector v-model="statusGroup.period"></period-selector></v-flex>
                      </v-layout>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-layout>
            </v-container>
          </v-tab-item>
          <!--<v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="7">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-data-table loading="true" :headers="headersInstallation" :items="installationArticles" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1 departmentUserList">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="50%">{{ props.item.code }}</td>
                      <td width="50%" class="text-xs-right"><v-text-field label="Installation Article" v-model="props.item.value" single-line solo></v-text-field></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>-->
          <v-tab-item class="quoteEditScreen pl-4 pr-4 pt-4 pb-4" :key="8">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>

                <!--<v-flex lg12>
                  <div class="screenTip">
                        <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> Switch on the columns
                          that are required on the Edit Quote Screen.
                        </span>
                  </div>
                </v-flex>
                    <v-container grid-list-xl style="padding-top: 10px !important;">
                      <h3>GENERAL</h3>
                      <v-layout row wrap>
                        <v-flex lg3>
                          <label class="blackLabel">Can Add More Rows</label>
                          <v-switch v-model="objDepartmentEdit.can_add_rows" single-line solo></v-switch>
                        </v-flex>
                        <v-flex lg6>
                          <label class="blackLabel">Tallisman</label>
                          <v-switch v-model="objDepartmentEdit.linked_items" @change="fncCheckTallisman()" single-line solo></v-switch>
                        </v-flex>-->

                <v-flex lg12>
                  <div class="screenTip">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> Switch on the columns
                      that are required on the Edit Quote Screen.
                    </span>
                  </div>
                </v-flex>
                <h3>GENERAL</h3>
                <v-flex lg3>
                  <label class="blackLabel">Can Add More Rows/Products</label>
                  <v-switch v-model="objDepartmentEdit.can_add_rows" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Calculator Dropdown</label>
                  <v-switch v-model="calculator" single-line solo></v-switch>
                  <span>Select a product from a calculator that is mapped to this department. </span>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Location</label>
                  <v-switch v-model="location" single-line solo></v-switch>
                  <span>Used to group line items on PDF</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <h3>PRODUCT</h3>
                <v-flex lg3>
                  <label class="blackLabel">Article Description</label>
                  <v-switch v-model="articleDescription" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">BW Article No.</label>
                  <v-switch v-model="bwArticleNo" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Product Description</label>
                  <v-switch v-model="productDescription" single-line solo></v-switch>
                  <span>Description captured in the template data and comes from the Spine.  </span>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Vendor</label>
                  <v-switch v-model="vendor" single-line solo></v-switch>
                  <span>As displayed in M050.  </span>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Product Code</label>
                  <v-switch v-model="plantCode" single-line solo></v-switch>
                  <span>Used when Article Number is used for multiple products</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <h3>PRICING</h3>
                <v-flex lg3>
                  <label class="blackLabel">Quantity</label>
                  <v-switch v-model="quantity" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">UOM</label>
                  <v-switch v-model="uom" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Unit Selling Price ( inc VAT )</label>
                  <v-switch v-model="unitTotalIncVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Unit Selling Price ( ex VAT )</label>
                  <v-switch v-model="unitSellingPriceExVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Total (inc VAT)</label>
                  <v-switch v-model="totalIncVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Vendor Unit Cost (ex VAT)</label>
                  <v-switch v-model="vendorUnitCostExVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Unit Vat</label>
                  <v-switch v-model="unitVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Margin</label>
                  <v-switch v-model="margin" single-line solo></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <h3>HIRE/DELIVERY</h3>
                <v-flex lg3>
                  <label class="blackLabel">Hire Date</label>
                  <v-switch v-model="hireDate" single-line solo></v-switch>
                  <span>Talisman Calc</span>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Hire Period</label>
                  <v-switch v-model="hirePeriod" single-line solo></v-switch>
                  <span>Talisman Calc</span>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Delivery Method</label>
                  <v-switch v-model="deliveryMethod" single-line solo></v-switch>
                  <span>Talisman Calc</span>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Receival Time</label>
                  <v-switch v-model="receivalTime" single-line solo></v-switch>
                  <span>Talisman Calc</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="8">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg10>
                  <div class="screenTip">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> If there are articles that have a different margin to that set in the department you can set it here.
                      <br>If the margin can be edited for the department but there are certain articles <b>can not be changed</b> you
                      can turn them off here.  <br><b>NOTE:</b> If the margins are set to NOT be editable at department level the below
                      switches do not apply.
                    </span>
                  </div>
                </v-flex>
                <v-flex lg2>
                  <input type="file" id="articleMarginImport" @change="fncSetArticleMargins">
                </v-flex>
                <v-data-table loading="true" :headers="marginHeaders" :items="objDepartmentEdit.article_margins" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow">
                      <td width="20%"><v-text-field label="Description" v-model="objDepartmentEdit.article_margins[props.index].description" single-line solo></v-text-field></td>
                      <td width="20%"><v-text-field label="Product Code" v-model="objDepartmentEdit.article_margins[props.index].article" single-line solo></v-text-field></td>
                      <td width="20%"><v-text-field label="Margin" v-model="objDepartmentEdit.article_margins[props.index ].margin" single-line solo></v-text-field></td>
                      <td width="20%"><v-switch label="Can Override Margin" v-model="objDepartmentEdit.article_margins[props.index ].override"></v-switch></td>
                      <td width="20%"><v-switch label="Can Override Cost Price" v-model="objDepartmentEdit.article_margins[props.index ].override_cost"></v-switch></td>
                    </tr>
                  </template>
                </v-data-table>
                <v-flex lg3>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddProductCodeMargin()">Add Product Code Margin</v-btn>
                </v-flex>
                <!--<v-flex lg3 v-for="(product_code, index) in objDepartmentEdit.article_margins">
                  <v-text-field label="Product Code" v-model="objDepartmentEdit.article_margins[index].value" single-line solo></v-text-field>-->
                <!--<a @click="fncRemoveDepartmentRange(index)" class="departmentRangeRemove">Remove</a>-->
                <!--</v-flex>-->
                <!--<v-flex lg12>
                  <label class="blackLabel">* Bank Details:</label>
                  <v-text-field label="Bank Details" v-model="objDepartmentEdit.bank_details" multi-line solo></v-text-field>
                  <v-switch label="Override Store Bank Details" v-model="objDepartmentEdit.bank_override"></v-switch>
                </v-flex>
                <v-flex lg12>
                  <label class="blackLabel">* Terms and Conditions:</label>
                  <v-text-field label="Terms and Conditions" v-model="objDepartmentEdit.terms_and_conditions" multi-line solo></v-text-field>
                </v-flex>-->
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="9">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <div class="screenTip">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> Available shortcodes:<br>
                     <table class="delivery-Note-Tip-Table" cellpadding="0" cellspacing="">
                       <tr>
                         <td> <b>[ITEM]</b></td>
                         <td>name from line item data</td>
                          <td> <b>[QUANTITY]</b></td>
                         <td>quantity from line item data</td>
                       </tr>
                       <tr>
                         <td> <b>[MATERIAL]</b></td>
                         <td>material from line item data (boardcutting)</td>
                          <td> <b>[COLOUR]</b></td>
                         <td>colour from line item data (boardcutting)</td>
                       </tr>
                        <tr>
                         <td> <b>[CUT_PIECES]</b></td>
                         <td>cut pieces from line item data (boardcutting)</td>
                          <td> <b>[SHEETS]</b></td>
                         <td>sheets from line item data (boardcutting)</td>
                       </tr>
                     </table>



                    </span>
                  </div>
                </v-flex>
                <v-btn color="success" @click="fncAddTemplate">Add Row</v-btn>
                <v-data-table loading="true" :headers="headersTemplate" :items="objDepartmentEdit.delivery_note_template" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1 departmentUserList">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="30%"><v-text-field label="Header" v-model="props.item.header" single-line solo></v-text-field></td>
                      <td width="30%" class="text-xs-right"><v-select label="Type" class="dropdown" v-model="props.item.value" :items="templateItems" item-value="id" item-text="name" autocomplete solo single-line></v-select></td>
                      <td width="30%" class="text-xs-right"><v-text-field label="Shortcode" v-model="props.item.shortcode" single-line solo></v-text-field></td>
                      <td width="10%"><a @click="fncDeleteTemplate(props.index)"><i class="material-icons">delete</i></a></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="addressSelected == false" :disabled="true" @click.stop="fncUpdateDepartment()">Update</v-btn>
            <v-btn color="success" class="text-xs-right" v-else :disabled="update_vars" @click.stop="fncUpdateDepartment()">Update</v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import StatusSelector from "../components/StatusSelector";
  import PeriodSelector from "../components/PeriodSelector";
  export default {
    name: 'Settings',
    components: {PeriodSelector, StatusSelector},
    data() {
      return {
        calculator: false,
        location: false,
        articleDescription: false,
        bwArticleNo: false,
        vendor: false,
        plantCode: false,
        productDescription: false,
        quantity: false,
        uom: false,
        hireDate: false,
        hirePeriod: false,
        deliveryMethod: false,
        receivalTime: false,
        unitSellingPriceExVat: false,
        unitVat: false,
        unitTotalIncVat: false,
        totalIncVat: false,
        vendorUnitCostExVat: false,
        margin: false,
        statusRules: [],
        isAddValid: false,
        articleImport: '',
        search: '',
        departmentName: '',
        departmentDescription: '',
        serviceType: [
          { id: 1, name: 'Contact Customer' },
          { id: 2, name: 'Request Quote' },
          { id: 3, name: 'Request Measure To Quote' },
          { id: 4, name: 'Request Measure To Quote - No Call Out Fee' },
          { id: 5, name: 'Request Calculator' }
        ],
        designationType: [
          { id: 1, name: 'Service Form' },
          { id: 2, name: 'App' }
        ],
        nameRules: [
          v => !!v || 'Department name is required',
        ],
        regionHeader: [
          { text: 'Select', value: '' },
          { text: 'Name', value: 'name' }
        ],
        descriptionRules: [
          v => !!v || 'Department description is required',
        ],
        branchRules: [
          v => !!v || 'Department store is required',
        ],
        addressSelected: true,
        headers: [
          { text: 'Name', value: 'name', width: '50%' },
          { text: 'Surname', value: 'surname', width: '50%' }
        ],
        marginHeaders: [
          { text: 'Description', value: 'article', width: '20%' },
          { text: 'Article', value: 'article', width: '20%' },
          { text: 'Margin', value: 'margin', width: '20%' },
          { text: '', value: 'margin', width: '20%' },
          { text: '', value: 'margin', width: '20%' }
        ],
        headersInstallation: [
          { text: 'Article', value: 'name', width: '50%' },
          { text: 'Installation Article', value: 'surname', width: '50%' }
        ],
        ruleHeaders: [
          { text: 'Service Type', value: 'name', width: '15%' },
          { text: 'Originator', value: 'description', width: '20%' },
          { text: 'Process Roles To Display', value: 'description', width: '25%' },
          { text: 'Designation', value: 'created_on', width: '15%' },
          { text: 'Status', value: 'created_on', width: '15%' },
          { text: 'Delete', value: 'delete', width: '10%' }
        ],
        objWidgetEdit: {
          statusList: this.departmentStatuses,
          headers: [
            {
              text: 'Group',
              align: 'left',
              sortable: false,
              value: 'label'
            },
            {
              text: 'Initial Status',
              align: 'center',
              sortable: false,
              value: 'status_initial'
            },
            {
              text: 'End Status',
              align: 'center',
              sortable: false,
              value: 'status_end'
            },
            {
              text: 'Period',
              align: 'center',
              sortable: false,
              value: 'period'
            }
          ],
          widgets: {
            ESCALATION: {
              title: 'Escalation Widget',
              groups: {
                'New Leads Not Actioned': {
                  value: false,
                  label: 'New Leads Not Actioned',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Customer Requirements not Finalised': {
                  value: false,
                  label: 'Customer Requirements not Finalised',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Requirements not sent to Design Team': {
                  value: false,
                  label: 'Requirements not sent to Design Team',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Quote not yet completed by Design Team': {
                  value: false,
                  label: 'Quote not yet completed by Design Team',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Quote should have been sent to Customer': {
                  value: false,
                  label: 'Quote should have been sent to Customer',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have followed up': {
                  value: false,
                  label: 'Should have followed up',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have got Answer from customer': {
                  value: false,
                  label: 'Should have got Answer from customer',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have sent Updated quote': {
                  value: false,
                  label: 'Should have sent Updated quote',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have checked out by now': {
                  value: false,
                  label: 'Should have checked out by now',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have been Manufactured': {
                  value: false,
                  label: 'Should have been Manufactured',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have been Delivered': {
                  value: false,
                  label: 'Should have been Delivered',
                  status_initial: {},
                  status_end: {},
                  period: ''
                }
              }
            }
          }
        },
        installationArticles: [],
        templateItems: [{id: 'class', name: 'Class'},{id: 'shortcode', name: 'Shortcode'}]
      };
    },
    methods: {
      fncDeleteTemplate( index ){
        var newTemplates = []
        for( var d in this.objDepartmentEdit.delivery_note_template ) {
          if( d != index ) {
            newTemplates.push( this.objDepartmentEdit.delivery_note_template[d] );
          }
        }
        this.objDepartmentEdit.delivery_note_template = newTemplates;
      },
      fncAddTemplate() {
        this.objDepartmentEdit.delivery_note_template.push({header: '', shortcode: ''})
      },
      fncCheckTallisman() {
        if( this.objDepartmentEdit.linked_items == false ) {
          this.plantCode = false;
          this.hireDate = false;
          this.hirePeriod = false;
          this.deliveryMethod = false;
          this.receivalTime = false;
        }
      },
      fncDeleteStatusRule( rule ) {

        var newRules = [];
        for( var r in this.objDepartmentEdit.status_rules ) {
          if( this.objDepartmentEdit.status_rules[r].id != rule.id ) {
            newRules.push( this.objDepartmentEdit.status_rules[r] );
          }
        }

        this.objDepartmentEdit.status_rules = newRules;
      },
      fncAddStatusRules() {
        var ruleId = this.objDepartmentEdit.status_rules.length + 1;
        var newRule = { id: ruleId, type: '', originator: [], roles: [], designation: [], status: '' }
        this.objDepartmentEdit.status_rules.push( newRule );
      },
      fncSetImageObj(e) {
        var files = e.target.files || e.dataTransfer.files;
        var reader = new FileReader();
        var vm = this;
        reader.onload = function(e) {
          var articleNumbers = reader.result;
          var articleRows = articleNumbers.split("\r\n");
          if( articleRows.length > 0 ) {
            vm.objDepartmentEdit.product_codes = [];
            for( var a in articleRows ) {
              if( articleRows[a] != '' ) {
                vm.objDepartmentEdit.product_codes.push({value: articleRows[a]});
              }
            }
          }
          /*vm.objRows = articleNumbers.split("\r\n");
          vm.fileName = files[0].name;*/
        }
        reader.readAsText(files[0]);
      },
      fncSetArticleMargins(e) {
        var files = e.target.files || e.dataTransfer.files;
        var reader = new FileReader();
        var vm = this;
        reader.onload = function(e) {
          var articleNumbers = reader.result;
          var articleRows = articleNumbers.split("\r\n");
          if( articleRows.length > 0 ) {
            vm.objDepartmentEdit.article_margins = [];
            for( var a in articleRows ) {
              var split = articleRows[a].split(',');
              if( articleRows[a] != '' ) {
                vm.objDepartmentEdit.article_margins.push({article: split[0], margin: split[1], override: true});
              }
            }
          }
          /*vm.objRows = articleNumbers.split("\r\n");
          vm.fileName = files[0].name;*/
        }
        reader.readAsText(files[0]);
      },
      fncRemoveDepartmentRange( index ) {
        var newProductCodes = [];
        for( var i in this.objDepartmentEdit.product_codes ) {
          if( i != index ) {
            newProductCodes.push(this.objDepartmentEdit.product_codes[i]);
          }
        }
        if( newProductCodes.length == 0 ) {
          newProductCodes = [{ value: '' }];
        }
        this.objDepartmentEdit.product_codes = newProductCodes;
      },
      fncAddProductCode() {
        this.objDepartmentEdit.product_codes.push({ value: '' });
      },
      fncAddProductCodeMargin() {
        this.objDepartmentEdit.article_margins.push({ article: '', margin: '', override: true });
      },
      fncHideModal() {
        window.location.reload();
        // this.$store.commit('hideModal');
      },
      fncCheckRegionSetup(regionId, regionStatus, regionParent) {
        this.addressSelected = true;
        this.$store.commit({
          type: 'fncCheckRegionSetup',
          regionId: regionId,
          regionStatus: regionStatus,
          parent: regionParent
        })
        if (regionStatus == false) {
          this.$store.commit('fncHideRegionParent', regionParent)
        }
      },
      fncUpdateDepartment() {

        var editForm = {};
        editForm.linkedItems = this.linkedItems;
        editForm.calculator = this.calculator;
        editForm.location = this.location;
        editForm.articleDescription = this.articleDescription;
        editForm.bwArticleNo = this.bwArticleNo;
        editForm.vendor = this.vendor;
        editForm.plantCode = this.plantCode;
        editForm.productDescription = this.productDescription;
        editForm.quantity = this.quantity;
        editForm.uom = this.uom;
        editForm.hireDate = this.hireDate;
        editForm.hirePeriod = this.hirePeriod;
        editForm.deliveryMethod = this.deliveryMethod;
        editForm.receivalTime = this.receivalTime;
        editForm.unitSellingPriceExVat = this.unitSellingPriceExVat;
        editForm.unitVat = this.unitVat;
        editForm.unitTotalIncVat = this.unitTotalIncVat;
        editForm.totalIncVat = this.totalIncVat;
        editForm.vendorUnitCostExVat = this.vendorUnitCostExVat;
        editForm.margin = this.margin;

        this.objDepartmentEdit.edit_form_fields = editForm;
        this.objDepartmentEdit.delivery_note_template = JSON.stringify( this.objDepartmentEdit.delivery_note_template );

        this.objDepartmentEdit.widget_rules = this.objWidgetEdit.widgets;
        this.objDepartmentEdit.installation_articles = [];
        this.$store.dispatch({
          type: 'fncUpdateDepartment',
          departmentDetails: {
            departmentRegions: this.userRegions
          }
        });
      },
      fncEditDeparment() {
        this.objDepartmentEdit.widget_rules = this.objWidgetEdit.widgets;
        this.$store.dispatch('fncUpdateDepartment');
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'runAdd',
        'objDepartmentEdit',
        'branchList',
        'departmentRangesList',
        'departmentUsers',
        'departmentStatuses',
        'departmentLoader',
        'vendorList',
        'userRoles',
        'statusList'
        //'userRegions'
      ]),
      update_vars(){
        // if (this.isAddValid && this.objDepartmentEdit.product_codes.every(item => item.value !== '')) {
        if (this.isAddValid) {
          return false;
        } else {
          return true;
        }
      },

      selectedWidgetStatusCollection() {
        const widgetKeys = Object.keys(this.objWidgetEdit.widgets);

        const statusIdRanges = [];
        const selectionStatus = [];
        const statusIds = [];

        for (let s = 0; s < this.statusList.length; s++) {
          statusIds[s] = this.statusList[s].id;
        }

        if (widgetKeys.length > 0) {
          for (let i = 0; i < widgetKeys.length; i++) {
            let widgetSelections = this.objWidgetEdit.widgets[widgetKeys[i]];
            let widgetSelectionKeys = Object.keys(widgetSelections.groups);
            statusIdRanges[widgetKeys[i]] = [];
            selectionStatus[widgetKeys[i]] = [];

            for (let wsk = 0; wsk < widgetSelectionKeys.length; wsk++) {
              let initial = parseInt(widgetSelections.groups[widgetSelectionKeys[wsk]].status_initial);
              let final = parseInt(widgetSelections.groups[widgetSelectionKeys[wsk]].status_end);
              selectionStatus[widgetKeys[i]][wsk] = [];

              if (!isNaN(initial) || !isNaN(final)) {
                if (!isNaN(initial)) {
                  selectionStatus[widgetKeys[i]][wsk].push(statusIds.indexOf(initial));
                }
                if (!isNaN(final)) {
                  selectionStatus[widgetKeys[i]][wsk].push(statusIds.indexOf(final))
                }
              }
            }

            let selections = {
              ranges: [],
              flattened: [],
              single: null,
              hasSingle: false,
              last: 0,
              first: null
            };

            for (let ss = 0; ss < selectionStatus[widgetKeys[i]].length; ss++) {
              let selectionStatusItem = selectionStatus[widgetKeys[i]][ss];
              let selectionStatusRange = [];

              if (selectionStatusItem.length === 2) {
                for (let n = selectionStatusItem[0]; n <= selectionStatusItem[1]; n++) {
                  selectionStatusRange.push(n);
                }
              }

              if (selectionStatusItem.length === 1) {
                selectionStatusRange.push(selectionStatusItem[0])
                selections.hasSingle = true;
              }

              if (selectionStatusRange.length > 0) {
                selections.ranges.push(selectionStatusRange);
              }
            }

            // find the first single and the last selected item
            for (let ssr = 0; ssr < selections.ranges.length; ssr++) {
              selections.first = selections.first === null ? (!selections.hasSingle && selections.ranges[ssr].length > 0) ? selections.ranges[ssr][0] : selections.first : selections.first;

              if (selections.hasSingle && selections.ranges[ssr].length === 1) {
                selections.single = selections.ranges[ssr][0];
              }
              for (let ssru = 0; ssru < selections.ranges[ssr].length; ssru++) {
                selections.last = selections.ranges[ssr][ssru] > selections.last ? selections.ranges[ssr][ssru] : selections.last;
              }
            }

            if (selections.hasSingle) {
              // Block out any options before the single selection
              if (selections.single !== null) {
                let preIndexes = [];
                for (let i = 0; i < selections.single; i++) {
                  preIndexes.push(i);
                }
                selections.ranges.push(preIndexes);
              }

              // block out any previously selected ranges to prevent overlap
              if (selections.single !== null && selections.ranges.length > 0) {
                let balanceOfIndexes = [];
                for (let i = 0; i < selections.ranges.length; i++) {
                  if (selections.single < selections.ranges[i][0]) {
                    for (let n = selections.ranges[i][0]; n < this.statusList.length - 1; n++) {
                      balanceOfIndexes.push(n);
                    }
                    break;
                  }
                }
                selections.ranges.push(balanceOfIndexes);
              }
            } else {
              if (selections.single !== null) {
                selections.ranges.push(selections.single)
              }
            }

            // flatten the selections into a single array
            for (let i = 0; i < selections.ranges.length; i++) {
              for (let j = 0; j < selections.ranges[i].length; j++) {
                if (selections.single !== selections.ranges[i][j]) {
                  selections.flattened[selections.ranges[i][j]] = selections.ranges[i][j];
                }
              }
            }

            for (let s = 0; s < this.statusList.length; s++) {
              if (selections.flattened.includes(s)) {
                statusIdRanges[widgetKeys[i]][this.statusList[s].id] = this.statusList[s].id;
              }
            }
          }
        }

        return statusIdRanges;
      }
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateVendors');
      this.$store.dispatch('fncPopulateRoles');
      this.$store.commit('fncEmptyStatusList');
      this.$store.dispatch('fncPopulateStatusList');

      // console.log( this.objDepartmentEdit.installation_articles );
    },
    created(){
      this.$store.dispatch('fncPopulateBranches');
      this.$store.dispatch('fncPopulateDepartmentUsers', this.objDepartmentEdit.id);
      this.$store.dispatch('fncPopulateDepartmentStatuses', {
        departmentId: this.objDepartmentEdit.id,
        manufacturer: this.objDepartmentEdit.manufacturer
      });

      if( this.objDepartmentEdit.product_codes.length == 0 ) {
        this.objDepartmentEdit.product_codes = [{ value: '' }];
      }
    },
    mounted() {

      if( this.objDepartmentEdit.delivery_note_template == 'null' || this.objDepartmentEdit.delivery_note_template == null || this.objDepartmentEdit.delivery_note_template == '' ) {
        this.objDepartmentEdit.delivery_note_template = [];
      } else {
        this.objDepartmentEdit.delivery_note_template = JSON.parse( this.objDepartmentEdit.delivery_note_template );
      }

      // setting up installation articles
      if( this.objDepartmentEdit.installation_articles == 'null' || this.objDepartmentEdit.installation_articles == null || this.objDepartmentEdit.installation_articles == '' ) {
        for( var p in this.objDepartmentEdit.product_codes ) {
          this.installationArticles.push( { code: this.objDepartmentEdit.product_codes[p].value, value: '' } );
        }
      } else {
        this.objDepartmentEdit.installation_articles = JSON.parse( this.objDepartmentEdit.installation_articles );
        this.installationArticles = this.objDepartmentEdit.installation_articles;
      }

      if ( typeof this.objDepartmentEdit.widget_rules !== "undefined" && this.objDepartmentEdit.widget_rules !== '') {
        this.objWidgetEdit.widgets = this.objDepartmentEdit.widget_rules;
      }

      if( this.objDepartmentEdit.status_rules == '' ) {
        this.objDepartmentEdit.status_rules = [];
      } else {
        this.objDepartmentEdit.status_rules = JSON.parse( this.objDepartmentEdit.status_rules );
        if( this.objDepartmentEdit.status_rules == null || this.objDepartmentEdit.status_rules == 'null' ) {
          this.objDepartmentEdit.status_rules = [];
        }
      }
      if( this.objDepartmentEdit.status_rules != 'null' && this.objDepartmentEdit.status_rules != null && this.objDepartmentEdit.status_rules.length > 0 ) {
        for( var r in this.objDepartmentEdit.status_rules ) {

          this.objDepartmentEdit.status_rules[r].id = parseInt( this.objDepartmentEdit.status_rules[r].id );
          this.objDepartmentEdit.status_rules[r].type = parseInt( this.objDepartmentEdit.status_rules[r].type );
          this.objDepartmentEdit.status_rules[r].status = parseInt( this.objDepartmentEdit.status_rules[r].status );

          if( this.objDepartmentEdit.status_rules[r].designation.length > 0 ) {
            for( var d in this.objDepartmentEdit.status_rules[r].designation ) {
              this.objDepartmentEdit.status_rules[r].designation[d] = parseInt( this.objDepartmentEdit.status_rules[r].designation[d] );
            }
          }

          if( this.objDepartmentEdit.status_rules[r].roles != undefined && this.objDepartmentEdit.status_rules[r].roles.length > 0 ) {
            for( var d in this.objDepartmentEdit.status_rules[r].roles ) {
              this.objDepartmentEdit.status_rules[r].roles[d] = parseInt( this.objDepartmentEdit.status_rules[r].roles[d] );
            }
          }

          if( this.objDepartmentEdit.status_rules[r].originator != undefined && this.objDepartmentEdit.status_rules[r].originator.length > 0 ) {
            for( var d in this.objDepartmentEdit.status_rules[r].originator ) {
              this.objDepartmentEdit.status_rules[r].originator[d] = parseInt( this.objDepartmentEdit.status_rules[r].originator[d] );
            }
          }

        }
      }
      if( this.objDepartmentEdit.can_add_rows == '1' ) { this.objDepartmentEdit.can_add_rows = true; } else { this.objDepartmentEdit.can_add_rows = false; }
      if( this.objDepartmentEdit.linked_items == '1' ) { this.objDepartmentEdit.linked_items = true; } else { this.objDepartmentEdit.linked_items = false; }

      if( this.objDepartmentEdit.hide_quote_edit == '0' || this.objDepartmentEdit.hide_quote_edit == false ) {
        this.objDepartmentEdit.hide_quote_edit = false;
      } else {
        this.objDepartmentEdit.hide_quote_edit = true;
      }

      if( this.objDepartmentEdit.can_update_sales_margin == null || this.objDepartmentEdit.can_update_sales_margin == 'null' || this.objDepartmentEdit.can_update_sales_margin == '' || this.objDepartmentEdit.can_update_sales_margin == '0' || this.objDepartmentEdit.can_update_sales_margin == false ) {
        this.objDepartmentEdit.can_update_sales_margin = false;
      } else {
        this.objDepartmentEdit.can_update_sales_margin = true;
      }

      if( this.objDepartmentEdit.can_update_installation_margin == null || this.objDepartmentEdit.can_update_installation_margin == 'null' || this.objDepartmentEdit.can_update_installation_margin == '' || this.objDepartmentEdit.can_update_installation_margin == '0' || this.objDepartmentEdit.can_update_installation_margin == false ) {
        this.objDepartmentEdit.can_update_installation_margin = false;
      } else {
        this.objDepartmentEdit.can_update_installation_margin = true;
      }

      if( this.objDepartmentEdit.can_update_cost_price == null || this.objDepartmentEdit.can_update_cost_price == 'null' || this.objDepartmentEdit.can_update_cost_price == '' || this.objDepartmentEdit.can_update_cost_price == '0' || this.objDepartmentEdit.can_update_cost_price == false ) {
        this.objDepartmentEdit.can_update_cost_price = false;
      } else {
        this.objDepartmentEdit.can_update_cost_price = true;
      }

      if( this.objDepartmentEdit.can_update_cost_price_installation == null || this.objDepartmentEdit.can_update_cost_price_installation == 'null' || this.objDepartmentEdit.can_update_cost_price_installation == '' || this.objDepartmentEdit.can_update_cost_price_installation == '0' || this.objDepartmentEdit.can_update_cost_price_installation == false ) {
        this.objDepartmentEdit.can_update_cost_price_installation = false;
      } else {
        this.objDepartmentEdit.can_update_cost_price_installation = true;
      }

      if( this.objDepartmentEdit.show_po_spec == null || this.objDepartmentEdit.show_po_spec == 'null' || this.objDepartmentEdit.show_po_spec == '' || this.objDepartmentEdit.show_po_spec == '0' || this.objDepartmentEdit.show_po_spec == false ) {
        this.objDepartmentEdit.show_po_spec = false;
      } else {
        this.objDepartmentEdit.show_po_spec = true;
      }

      if( this.objDepartmentEdit.edit_form_fields != undefined && this.objDepartmentEdit.edit_form_fields != '' && this.objDepartmentEdit.edit_form_fields != 'null' && this.objDepartmentEdit.edit_form_fields != null) {
        this.objDepartmentEdit.edit_form_fields = JSON.parse( this.objDepartmentEdit.edit_form_fields );
      } else {
        this.objDepartmentEdit.edit_form_fields = [];
      }

      if( this.objDepartmentEdit.article_margins != undefined && this.objDepartmentEdit.article_margins != '' ) {
        this.objDepartmentEdit.article_margins = JSON.parse( this.objDepartmentEdit.article_margins );

        for( var am in this.objDepartmentEdit.article_margins ) {
          if(this.objDepartmentEdit.article_margins[am].override == 'false' || this.objDepartmentEdit.article_margins[am].override == '') {
            this.objDepartmentEdit.article_margins[am].override = false;
          } else {
            this.objDepartmentEdit.article_margins[am].override = true;
          }
          if(this.objDepartmentEdit.article_margins[am].override_cost == 'false' || this.objDepartmentEdit.article_margins[am].override_cost == '') {
            this.objDepartmentEdit.article_margins[am].override_cost = false;
          } else {
            this.objDepartmentEdit.article_margins[am].override_cost = true;
          }
        }

      } else {
        if( this.objDepartmentEdit.product_codes.length > 0 ) {

          var margins = [];
          for( var p in this.objDepartmentEdit.product_codes ) {
            margins.push({article: this.objDepartmentEdit.product_codes[p].value, margin: '', override: true, override_cost: true });
          }

          this.objDepartmentEdit.article_margins = margins;

        } else {
          this.objDepartmentEdit.article_margins = [];
        }
      }

      for( var f in this.objDepartmentEdit.edit_form_fields ) {
        if( this.objDepartmentEdit.edit_form_fields[f] == 'false' ) {
          this.objDepartmentEdit.edit_form_fields[f] = false;
        } else {
          this.objDepartmentEdit.edit_form_fields[f] = true;
        }
      }


      if( this.objDepartmentEdit.edit_form_fields != null && this.objDepartmentEdit.edit_form_fields != 'null' ) {
        this.calculator = this.objDepartmentEdit.edit_form_fields.calculator == undefined ? false : this.objDepartmentEdit.edit_form_fields.calculator;
        this.location = this.objDepartmentEdit.edit_form_fields.location == undefined ? false : this.objDepartmentEdit.edit_form_fields.location;
        this.articleDescription = this.objDepartmentEdit.edit_form_fields.articleDescription == undefined ? false : this.objDepartmentEdit.edit_form_fields.articleDescription;
        this.bwArticleNo = this.objDepartmentEdit.edit_form_fields.bwArticleNo == undefined ? false : this.objDepartmentEdit.edit_form_fields.bwArticleNo;
        this.vendor = this.objDepartmentEdit.edit_form_fields.vendor == undefined ? false : this.objDepartmentEdit.edit_form_fields.vendor;
        this.plantCode = this.objDepartmentEdit.edit_form_fields.plantCode == undefined ? false : this.objDepartmentEdit.edit_form_fields.plantCode;
        this.productDescription = this.objDepartmentEdit.edit_form_fields.productDescription == undefined ? false : this.objDepartmentEdit.edit_form_fields.productDescription;
        this.quantity = this.objDepartmentEdit.edit_form_fields.quantity == undefined ? false : this.objDepartmentEdit.edit_form_fields.quantity;
        this.uom = this.objDepartmentEdit.edit_form_fields.uom == undefined ? false : this.objDepartmentEdit.edit_form_fields.uom;
        this.hireDate = this.objDepartmentEdit.edit_form_fields.hireDate == undefined ? false : this.objDepartmentEdit.edit_form_fields.hireDate;
        this.hirePeriod = this.objDepartmentEdit.edit_form_fields.hirePeriod == undefined ? false : this.objDepartmentEdit.edit_form_fields.hirePeriod;
        this.deliveryMethod = this.objDepartmentEdit.edit_form_fields.deliveryMethod == undefined ? false : this.objDepartmentEdit.edit_form_fields.deliveryMethod;
        this.receivalTime = this.objDepartmentEdit.edit_form_fields.receivalTime == undefined ? false : this.objDepartmentEdit.edit_form_fields.receivalTime;
        this.unitSellingPriceExVat = this.objDepartmentEdit.edit_form_fields.unitSellingPriceExVat == undefined ? false : this.objDepartmentEdit.edit_form_fields.unitSellingPriceExVat;
        this.unitVat = this.objDepartmentEdit.edit_form_fields.unitVat == undefined ? false : this.objDepartmentEdit.edit_form_fields.unitVat;
        this.unitTotalIncVat = this.objDepartmentEdit.edit_form_fields.unitTotalIncVat == undefined ? false : this.objDepartmentEdit.edit_form_fields.unitTotalIncVat;
        this.totalIncVat = this.objDepartmentEdit.edit_form_fields.totalIncVat == undefined ? false : this.objDepartmentEdit.edit_form_fields.totalIncVat;
        this.vendorUnitCostExVat = this.objDepartmentEdit.edit_form_fields.vendorUnitCostExVat == undefined ? false : this.objDepartmentEdit.edit_form_fields.vendorUnitCostExVat;
        this.margin = this.objDepartmentEdit.edit_form_fields.margin == undefined ? false : this.objDepartmentEdit.edit_form_fields.margin;
      }

    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
